<template>
  <el-row class="container">
    <!--用户个人信息-->
    <el-dialog
      :title="$t('user.userInfo')=='账户信息'?userTitle:userTitle1"
      :visible.sync="userInfoDialog"
      top="3%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="font-weight: bold;"
      :before-close="handleClose" id="userDetail">
        <div class="top_main_line"></div>
        <div  class="top_user_form"  v-show="editFlag">
          <el-form label-position="top" label-width="80px">
            <div class="top_user_marin">
              <el-form-item :label="$t('register.userName')">
                <el-input v-model="user.username" readonly style="width: 320px;" :placeholder="$t('user.placeholder')" ></el-input>
              </el-form-item>
            </div>
            <div class="top_user_marin reg_top">
              <el-form-item :label="$t('register.fullName')">
                <el-input v-model="user.name" style="width: 320px;" :placeholder="$t('register.fullName1')" ></el-input>
              </el-form-item>
            </div>
            <div class="top_user_marin">
              <el-form-item :label="$t('register.phone')">
                <el-input v-model="user.phone" readonly style="width: 320px;" :placeholder="$t('register.phone1')" ></el-input>
              </el-form-item>
            </div>
            <div class="top_user_marin reg_top">
              <el-form-item :label="$t('register.email')">
                <el-input v-model="user.email" style="width: 320px;" :placeholder="$t('register.email1')" ></el-input>
              </el-form-item>
            </div>
            <div class="top_user_marin">
              <el-form-item :label="$t('register.unitName')">
                <el-input v-model="user.unit" :placeholder="$t('register.unitName1')" ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="top_detail"  v-show="!editFlag">
          <div class="top_detail_content">
            <div class="user_content">
              <span class="span_1">{{$t('register.userName')}}：</span>
              <span class="span_2">{{user.username}}</span>
            </div>
            <div class="user_content">
              <span class="span_1">{{$t('register.fullName')}}：</span>
              <span class="span_2">{{user.name}}</span>
            </div>
            <div class="user_content">
              <span class="span_1">{{$t('register.phone')}}：</span>
              <span class="span_2">{{user.phone}}</span>
            </div>
            <div class="user_content">
              <span class="span_1">{{$t('register.email')}}：</span>
              <span class="span_2">{{user.email}}</span>
            </div>
            <div class="user_content">
              <span class="span_1">{{$t('register.unitName')}}：</span>
              <span class="span_2">{{user.unit}}</span>
            </div>
          </div>
        </div>
        <div class="top_main_line" style="margin-top:0px"></div>
        <div class="detail_btn">
            <el-button type="primary" class="btn_1" @click="handleClose">
              <span v-show="editFlag">{{$t('operate.cancel')}}</span>
              <span v-show="!editFlag">{{$t('operate.backPage')}}</span>
            </el-button>
            <el-button type="primary" class="btn_2" v-show="!editFlag" @click="editClick"><span>{{$t('operate.edit')}}</span></el-button>
            <el-button type="primary" class="btn_2" v-show="editFlag" @click="saveRegisterUser"><span>{{$t('operate.save')}}</span></el-button>
        </div>
    </el-dialog>
    <!--修改密码确认弹框-->
    <el-dialog
      :title="$t('operate.tips')"
      :visible.sync="tipsdDialog"
      top="3%"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      style="font-weight: bold;"
      :before-close="handleClose" id="updatePassword">
      <div  class="top_user_form" style="width:400px;height: 22px">
        {{$t('operate.resetPasswordTips')}}
      </div>
      <div class="detail_btn1">
        <el-button type="primary" class="btn_2" @click="determineDialog"><span>{{ $t('operate.determine') }}</span></el-button>
      </div>
    </el-dialog>
    <!--修改用户密码-->
    <el-dialog
      :title="$t('top.changePassword')"
      :visible.sync="updatePsdDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="3%"
      style="font-weight: bold;"
      :before-close="handleClose" id="updatePassword">
      <div class="top_main_line" style="width: 368px"></div>
      <div  class="top_user_form" style="width:368px;height: 390px">
        <el-form label-position="top" label-width="80px">
          <div class="top_user_marin">
            <el-form-item :label="$t('register.initPassword')">
              <el-input v-model="resetPwd.oldPwd" type="password" style="width: 320px;" :placeholder="$t('register.initPassword1')" ></el-input>
<!--              <div class="pass_tip">{{ $t('top.initPassword1') }}</div>-->
            </el-form-item>
          </div>
          <div class="top_user_marin">
            <el-form-item :label="$t('top.newPassword')">
              <el-input v-model="resetPwd.newPwd" type="password" style="width: 320px;" :placeholder="$t('top.newPassword1')" ></el-input>
              <div class="pass_tip">{{ $t('top.passwordTip') }}</div>
            </el-form-item>
          </div>
          <div class="top_user_marin" style="clear: both">
            <el-form-item :label="$t('top.confirmPassword')">
              <el-input v-model="resetPwd.entPwd" type="password" style="width: 320px;" :placeholder="$t('top.confirmPassword1')" ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="top_main_line" style="margin-top:0px;width: 368px"></div>
      <div class="detail_btn" style="width: 368px">
        <el-button type="primary" class="btn_1" @click="handleClose"><span>{{ $t('operate.cancel') }}</span></el-button>
        <el-button type="primary" class="btn_2" @click="savePassword"><span>{{ $t('operate.determine') }}</span></el-button>
      </div>
    </el-dialog>
    <!--头部-->
    <div class="shortcut">
      <div class="wrapper">
        <div class="logo" @click="goIndex">
          <img src="../assets/images/logo.png">-->
        </div>
        <div class="title">
          <ul class="font_size20 font_jzc" style="font-weight: 600; color: #272D2D;cursor: pointer">
            <li :class="clickBag=='n'?'top_click':''" @click="ngClick('n')">{{$t('product.ngName')}}</li>
            <li :class="clickBag=='a'?'top_click':''" style="margin-left:60px"  @click="auClick('a')">{{$t('product.auName')}}</li>
          </ul>
        </div>
        <ul style="margin-right:180px;">
          <li @click="loginClick" v-show="!user.username">
            <a href="#" class="font_size24 font_jzh" style="font-weight: 500;color: #272D2D;">{{ $t('user.login') }}</a>
          </li>
          <li @click="registerClick" v-show="!user.username && settingColumn.registrationSwitch==0">
            <a href="#" class="font_size24 font_jzh" style="font-weight: 500;color: #272D2D;">{{ $t('user.register') }}</a>
          </li>
<!--          <li>-->
<!--            <a href="#" class="font_size24 font_jzh" style="font-weight: 500;color: #272D2D;">我的订单</a>-->
<!--          </li>-->
          <el-dropdown trigger="click" style="margin-top: 10px;margin-left:16px;cursor: pointer" v-show="user.name">
              <span class="el-dropdown-link font_size24 font_jzh" style="font-weight: 500;color: #272D2D;">
                {{ user.name }}
                 <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            <el-dropdown-menu slot="dropdown" class="dropdownPop" >
              <el-dropdown-item>
                <div @click="myOrder">{{$t('top.myOrder')}}</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="userDetail">{{$t('top.accountDetails')}}</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="updatePassword">{{$t('top.changePassword')}}</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="logout">{{$t('top.logOut')}}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown   @command="changeLanguage" style="margin-top: 10px;margin-left:16px;cursor: pointer">
              <span class="el-dropdown-link font_size24 font_jzh" style="font-weight: 500;color: #272D2D;">
                {{$t('language.name')}}
                 <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </ul>
      </div>
    </div>
    <!--中间-->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </el-row>
</template>
<script>
import registerUserApi from '@/api/registerUser'
import {checkPassword} from "@/utils/index";
import {getUserId} from '@/utils/cookie'
  export default {
    name: 'home',
    data () {
      return {
        userTitle:"账户信息",
        userTitle1:"AccountInfo",
        defaultActiveIndex: "/",
        userInfoDialog:false,
        updatePsdDialog:false,
        editFlag:false,
        tipsdDialog:false,
        clickBag:'',
        userId:null,
        user:{
          username:'',
          name:'',
          unit:'',
          phone:'',
          email:'',
          status:null,
          notes:''
        },
        settingColumn:{
          registrationSwitch:null,
        },
        permissions:[],
        vaildNewPwd:'',
        resetPwd:{
          oldPwd:'',
          newPwd:'',
          entPwd:'',
        },
        loading: false,
        companyName: '',
        screenWidth: "",
        menuList:[
          {index:1,name:this.$t('product.ngName'),path:'/applicationManager'},
          {index:2,name:this.$t('product.auName'),path:'/sampleManager'},
        ],
        copyMenuList:[],
        menuItemList:[],
      }
    },
    created() {// 组件创建完后获取数据，
      localStorage.removeItem("reg_data");
      this.userId = getUserId()
      var user = JSON.parse(localStorage.getItem('web_user'));
      if(user){
        this.user = user;
      }
      console.log(this.user)
      this.getSettingColumn();
      this.fetchNavData();
      this.getLanguage();
      this.copyMenuList = this.menuList;
      this.clickBag = localStorage.getItem("create_click_bg");
    },
    methods: {
      getSettingColumn(){
        registerUserApi.getSettingColumn().then(response=> {
          if(response.data.code==0){
            this.settingColumn = response.data.result[0]
            localStorage.setItem("switch",this.settingColumn.registrationSwitch)
          }
        })
      },
      changeLanguage(command){
        this.$i18n.locale= command   //设置中英文模式
        localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
        this.menuList = [
          {index:1,name:this.$t('product.ngName'),path:'/applicationManager'},
          {index:2,name:this.$t('product.auName'),path:'/sampleManager'},
        ]
      },
      getLanguage(){
        if(localStorage.getItem("languageSet")){
          if(localStorage.getItem("languageSet")=="zh"){
            this.$i18n.locale=='zh'
          }else{
            this.$i18n.locale=='en'
          }
        }else{
          this.$i18n.locale=='zh'
        }
      },
      goIndex(){
        this.clickBag = "";
        localStorage.setItem('create_click_bg',"");
        this.$router.push({path: '/index'})
      },
      userDetail(){
        this.clickBag = "";
        this.userInfoDialog = true;
      },
      saveRegisterUser(){
        if(!this.user.name){
          this.$message.error(this.$t('register.fullName1'))
          return false;
        }
        if(!this.user.unit){
          this.$message.error(this.$t('register.unitName1'))
          return false;
        }
        registerUserApi.updateUser(this.user).then(response=> {
          if(response.data.code==0){
            this.editFlag = false;
            localStorage.setItem("web_user",JSON.stringify(this.user))
            this.$message.success(this.$t("operate.updateSuccess"))
          }else{
            this.$message.error("error");
          }
        })
      },
      updatePassword(){
        this.clickBag = "";
        this.updatePsdDialog = true;
      },
      savePassword(){
        if(checkPassword(this.resetPwd.newPwd)){
          this.$message.error(this.$t('top.passwordTip'))
          return;
        }
        if(checkPassword(this.resetPwd.entPwd)){
          this.$message.error(this.$t('top.passwordTip'))
          return;
        }
        if(this.resetPwd.newPwd!=this.resetPwd.entPwd){
          this.$message.error(this.$t("register.password2"))
          return false;
        }

        registerUserApi.resetPassword(this.user.id,this.resetPwd).then(response=> {
          if(response.data.code==0){
            this.tipsdDialog = true;
          }else if(response.data.code==9){
            this.$message.error(this.$t("top.updatePwd"))
          }else if(response.data.code==10){
            this.$message.error(this.$t("top.updatePwd1"))
          }
        })
      },
      determineDialog(){
        this.logout1();
      },
      loginClick(){
        this.clickBag = "";
        this.$router.push({path: '/login'})
      },
      registerClick(){
        this.clickBag = "";
        this.$router.push({path: '/register'})
      },
      ngClick(data){
        this.clickBag = data;
        localStorage.removeItem("create_order_pro")
        localStorage.setItem('click_route',"/ngsure");
        localStorage.setItem('create_click_bg',"n");
        this.$router.push({path: '/ngsure'})
      },
      auClick(data){
        this.clickBag = data;
        localStorage.removeItem("create_order_pro")
        localStorage.setItem('click_route',"/augury");
        localStorage.setItem('create_click_bg',"a");
        this.$router.push({path: '/augury'})
      },
      myOrder(){
        this.clickBag = "";
        this.$router.push({path: '/order'})
      },
      editClick(){
        this.editFlag = true;
        this.userTitle = "编辑账户信息"
        this.userTitle1 = "Edit Account Info"
      },
      cancel(){
        this.editFlag = false;
        this.userTitle = "账户信息"
        var user = JSON.parse(localStorage.getItem('web_user'));
        if(user){
          this.user = user;
        }
      },
      handleClose(){
        this.userTitle = "编辑账户信息"
        this.userTitle1 = "Account Info"
        this.userInfoDialog = false;
        this.updatePsdDialog = false;
        this.cancel();
      },

      logout(){
        //logout
        this.$confirm(this.$t("top.logOutTips"), this.$t("operate.tips"), {
          confirmButtonClass: 'el-button--warning'
        }).then(() => {
          this.$store.dispatch('LogOut').then(() => {
            localStorage.removeItem("web_login_time");
            localStorage.removeItem("web_login_password");
            localStorage.removeItem("web_user");
            localStorage.removeItem("create_click_bg");
            localStorage.removeItem("web_login_user");
            localStorage.removeItem("click_route");
            localStorage.removeItem("create_order_pro");
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }).catch(() => {});
      },
      logout1(){
        this.$store.dispatch('LogOut').then(() => {
          localStorage.removeItem("web_login_time");
          localStorage.removeItem("web_login_password");
          localStorage.removeItem("web_user");
          localStorage.removeItem("create_click_bg");
          localStorage.removeItem("web_login_user");
          localStorage.removeItem("click_route");
          localStorage.removeItem("create_order_pro");
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      handleSelect(index){
        this.defaultActiveIndex = index;
      },
      fetchNavData () { // 初始化菜单激活项
        var cur_path = this.$route.path; //获取当前路由
        var routers = this.$router.options.routes; // 获取路由对象
        var nav_type = "", nav_name = "";
        for (var i = 0; i < routers.length; i++) {
          var children = routers[i].children;
          if(children){
            for (var j = 0; j < children.length; j++) {
              var grand_children = children[j].children;
              if(grand_children){
                for (var k = 0; k < grand_children.length; k++) {
                  if (grand_children[k].path === cur_path) {
                    nav_type = routers[i].type;
                    nav_name = routers[i].name;
                    break;
                  }
                  // 如果该菜单下还有子菜单
                  if(children[j].children) {
                    let grandChildren = children[j].children;
                    for(let z=0; z<grandChildren.length; z++) {
                      if(grandChildren[z].path === cur_path) {
                        nav_type = routers[i].type;
                        nav_name = routers[i].name;
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.$store.state.topNavState = nav_type;  // 改变topNavState状态的值
        this.$store.state.leftNavState = nav_name;  // 改变leftNavState状态的值
        if(nav_type == "home"){
          this.defaultActiveIndex = "/";
        } else {
          this.defaultActiveIndex = "/" + nav_name + "Manager";
        }
      },
      jumpTo(url){
        this.defaultActiveIndex = url;
        this.$router.push(url); //用go刷新
      },

    },
    mounted() {
      let _this=this;
//根据自己需要来监听对应的key
      window.addEventListener("setItemEvent",function(e){
        if(e.key==="web_user"){
          _this.user = JSON.parse(e.newValue)
          console.log(_this.user)
        }
        if(e.key==="create_click_bg"){
          _this.clickBag = e.newValue;
        }
      })

    },
    watch: {
      '$route': function(to, from){ // 路由改变时执行
        // console.info("to.path:" + to.path);
        this.fetchNavData();
      },
      // '$route': 'fetchNavData',  //监听router值改变时，改变导航菜单激活项
      // screenWidth(nval, oval) {
      //   if (nval < oval) {
      //     this.getMenuList();
      //   } else {
      //     this.getMaxMenuList();
      //   }
      // }
    },
    computed: {
      collapse () {
        return this.$store.state.collapsed;　　//需要监听的数据
      }
    }
  }
</script>
<style>
 .wrapper {
   width: 1920px;
   min-width: 1440px;
   margin: 0 auto;
 }
.top_click{
  border-bottom: 4px solid #C9DA2C;
}
 /* 快捷菜单 */
 .shortcut {
   background-color: #FFFFFF;
 }

 .shortcut .wrapper {
   color: #fff;
   height: 100px;
 }
 .shortcut .wrapper .logo {
   width:229px;
   height:50px;
   margin-left:180px;
   margin-top:25px;
   float: left;
   cursor: pointer;
 }
 .shortcut .wrapper .title {
   margin-left:151px;
   float: left;
   text-decoration:none
 }


 .shortcut .wrapper ul {
   float: right;
   margin-top:25px;
 }

 .shortcut .wrapper li {
   float: left;
   height: 75px;
   line-height: 52px;
 }

 .shortcut .wrapper li a {
   padding: 0 16px;
   border-right: 1px solid #6666;
   font-size: 14px;
   color: #dcdcdc;
 }

 .shortcut .wrapper li .last {
   padding: 0 16px;
   border: none;
   font-size: 14px;
   color: #dcdcdc;
 }

 .shortcut .wrapper li span {
   display: inline-block;
   width: 11px;
   height: 16px;
   background-image: url(../assets/images/logo.png);
   /*background-position: -160px -70px;*/
   vertical-align: middle;
   margin-right: 10px;
 }
 .el-dialog__title {
   height: 28px;
   font-size: 20px;
   font-family: PingFangSC-Medium, PingFang SC;
   /*font-weight: 500;*/
   color: #171725 !important;
   line-height: 28px;
 }
 .el-dialog__headerbtn .el-dialog__close {
   color: #909399;
   background:#F6F6F6;
   border-radius: 5px;
   width: 30px;
   height: 30px;
   border: 1px dashed;
   font-size: 16px;
   line-height: 29px;
 }
 #userDetail .el-dialog {
   position: relative;
   margin: 0 auto 50px;
   background: #FFF;
   border-radius: 2px;
   -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
   box-shadow: 0 1px 3pxrgba(0,0,0,.3);
   -webkit-box-sizing: border-box;
   box-sizing: border-box;
   width: 736px;
 }
 #updatePassword .el-dialog {
   position: relative;
   margin: 0 auto 50px;
   background: #FFF;
   border-radius: 2px;
   -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
   box-shadow: 0 1px 3pxrgba(0,0,0,.3);
   -webkit-box-sizing: border-box;
   box-sizing: border-box;
   width: 368px;
 }

 .top_user_form{
   width: 736px;
   height: 365px;
   margin: 0px auto;
   padding-left: 24px;
   box-shadow: 0px 12px 30px 0px rgba(39,45,45,0.04);
   border-radius: 8px;
 }
 .top_detail{
   width: 736px;
   height: 300px;

   box-shadow: 0px 12px 30px 0px rgba(39,45,45,0.04);
   border-radius: 8px;
 }
 .top_detail_content{
   width: 690px;
   height: 273px;
   margin: 24px auto;
   background: rgba(246,246,246,0.5);
   border-radius: 4px;
 }
 .user_content{
   padding-top:24px;
   margin-left:24px
 }
 .span_1{
   height: 24px;
   font-size: 16px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #888B90;
   line-height: 24px;
 }
 .span_2{
   height: 24px;
   font-size: 16px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #272D2D;
   line-height: 24px;
 }
 .top_user_marin .el-input__inner{
   font-size: 16px;
   font-family: PingFangSC-Medium, PingFang SC;
   font-weight: 500;
   color: #272D2D;
   border: 1px solid #E9EAEA !important;
   height: 46px !important;
   width: 320px !important;
 }
 .top_user_marin{
   float: left;
   margin-top:24px;
 }
 .top_user_marin .el-form-item__label {
   font-size: 16px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: rgba(39,45,45,0.5);
   line-height: 24px;
 }
 .top_main_line{
   width: 736px;
   height: 1px;
   margin-top: 19px;
   background: #E9EAEA;
 }
 .pass_tip{
   width: 321px;
   height: 24px;
   font-size: 12px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: rgba(39,45,45,0.5);
 }
 .detail_btn{
   width:736px;
   height: 94px;
   text-align: right;
   padding: 28px;
   background: #FFFFFF;
 }
 .detail_btn1{
   height: 94px;
   text-align: right;
   padding: 28px;
   background: #FFFFFF;
 }
 .btn_1{
   width: 102px;
   height: 46px;
   background: #F6F6F6;
   border-radius: 4px;
 }
 .btn_1 span{
   height: 22px;
   font-size: 16px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #272D2D;
   line-height: 22px;
 }
 .btn_2{
   width: 118px;
   height: 46px;
   background: #0F4E9F;
   border-radius: 4px;
 }
 .btn_2 span{
   height: 22px;
   font-size: 16px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #FFFFFF;
   line-height: 22px;
 }
 .reg_top{
   /*margin-top:15px;*/
   margin-left:48px;
 }
</style>



// WEBPACK FOOTER //
// src/views/top.vue